export function 	getURLParam(name) {
  const value = window.location.search.match(
    new RegExp('[?&]' + name + '=([^&]*)(&?)', 'i'),
  );
  return value ? decodeURIComponent(value[1]) : value;
}